import React, { FC, useState } from "react";
import { Button, ButtonGroup, Typography, Box, Tooltip } from "@material-ui/core";
import InfoOutlinedIcon from '@material-ui/icons/InfoOutlined';
import constants from "./../../../../utils/constants";
import { Parser } from 'html-to-react';
import { useStyles } from "./styles";

interface Props {
  handleSeverityLevelChange: (level: string) => void;
}

const SeverityButtonGroup: FC<Props> = ({ handleSeverityLevelChange }) => {
  const classes = useStyles();
  const [active, setActive] = useState(constants.BOOK_CLOSURE_DASHBOARD.SEVERITY_LEVELS[3]);

  const handleOnClick = (level) => {
    handleSeverityLevelChange(level);
    setActive(level);
  };

  return (
    <>
      <Box className={classes.mainContainer}>
        <Box className={classes.innerContainer}>
          <Typography className={classes.typography}>Indicator Variance Filter</Typography>
          <Tooltip title={Parser().parse(constants.TOOLTIP_TITLES.BOOK_CLOSURE_SEVERITY)} placement="bottom" arrow>
            <InfoOutlinedIcon data-testid="severity-button-group" fontSize="small" color="action" /></Tooltip>
          <Typography className={classes.typography}>:</Typography>
        </Box>
        <ButtonGroup className={classes.buttonGroup}>
          {constants.BOOK_CLOSURE_DASHBOARD.SEVERITY_LEVELS.map((level) => {
            const isActive = active === level;
            return (
              <Button
                variant="text"
                key={level}
                onClick={() => handleOnClick(level)}
                className={`${classes.buttonTypography} ${classes[`button${level}`]} ${isActive ? classes[`buttonActive${level}`] : ''}`}
              >
                {level}
              </Button>
            )
          })}
        </ButtonGroup>
      </Box>
    </>
  );
}

export default SeverityButtonGroup;